import intl from "react-intl-universal";
import { TbAdjustmentsHorizontal, TbCalendar, TbCurrencyReal } from "react-icons/tb";
import { ValutField, ValutInput } from "../../../Components/Atoms/ValutInput";
import { ModernFilterBar } from "../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../Components/Molecules/Filters/ModernFilterPanels";
import { handleTaxIDInput } from "../../../Utils";
import {
  EMPTY_TICKETS_FILTERS,
  buildTicketsFilterTags,
  exportTicketsCsv,
  getTicketAnticipatedOptions,
  getTicketStatusOptions,
  hasActiveTicketsFilters,
  isTicketsChipFilterActive,
  removeTicketsFilterTag,
} from "./ticketsFilters";

const TicketsMoreFiltersForm = ({ draft, onChange }) => (
  <div className="extract-more-filters-form">
    <MoreFiltersDateSection draft={draft} onChange={onChange} />
    <MoreFiltersDateSection
      draft={draft}
      onChange={onChange}
      dateFromKey="dueDateFrom"
      dateToKey="dueDateTo"
      label={intl.get("tickets.filterDueDate")}
    />
    <MoreFiltersAmountSection draft={draft} onChange={onChange} idPrefix="tickets-more" />
    <MoreFiltersCheckboxSection
      label={intl.get("tickets.filterStatus")}
      options={getTicketStatusOptions()}
      selectedValues={draft.status ? [draft.status] : []}
      onChange={(values) => {
        const next =
          values.length <= 1
            ? values[0] || ""
            : values.find((value) => value !== draft.status) || "";
        onChange({ ...draft, status: next });
      }}
      idPrefix="tickets-more-status"
    />
    <MoreFiltersCheckboxSection
      label={intl.get("tickets.filterAnticipated")}
      options={getTicketAnticipatedOptions()}
      selectedValues={draft.anticipated ? [draft.anticipated] : []}
      onChange={(values) => {
        const next =
          values.length <= 1
            ? values[0] || ""
            : values.find((value) => value !== draft.anticipated) || "";
        onChange({ ...draft, anticipated: next });
      }}
      idPrefix="tickets-more-anticipated"
    />
    <section className="extract-more-filters-form__section">
      <ValutField label={intl.get("tickets.payer")} htmlFor="tickets-more-name">
        <ValutInput
          id="tickets-more-name"
          value={draft.name}
          onChange={(event) => onChange({ ...draft, name: event.target.value })}
        />
      </ValutField>
    </section>
    <section className="extract-more-filters-form__section">
      <ValutField label={intl.get("tickets.document")} htmlFor="tickets-more-document">
        <ValutInput
          id="tickets-more-document"
          value={draft.document}
          onChange={(event) =>
            onChange({ ...draft, document: handleTaxIDInput(event.target.value) })
          }
        />
      </ValutField>
    </section>
  </div>
);

export const TicketsFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
}) => {
  const statusOptions = getTicketStatusOptions();

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isTicketsChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isTicketsChipFilterActive(filters, "amount"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("tickets.filterStatus"),
      active: isTicketsChipFilterActive(filters, "status"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="tickets-filter" />;
      case "status":
        return (
          <CheckboxListFilterPanel
            options={statusOptions}
            selectedValues={draft.status ? [draft.status] : []}
            onChange={(values) => onChange({ ...draft, status: values[0] || "" })}
            idPrefix="tickets-status"
            singleSelect
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_TICKETS_FILTERS}
      searchPlaceholder={intl.get("tickets.searchPlaceholder")}
      filterButtons={filterButtons}
      moreFiltersActive={isTicketsChipFilterActive(filters, "more")}
      buildFilterTags={buildTicketsFilterTags}
      hasActiveFilters={hasActiveTicketsFilters}
      removeFilterTag={removeTicketsFilterTag}
      onExport={exportTicketsCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <TicketsMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        status: intl.get("tickets.filterStatus"),
      }}
      exportEmptyMessageKey="tickets.noRecordsFiltered"
    />
  );
};
